import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
} from "@material-ui/core";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useHistory, useLocation } from "react-router-dom";
import Services from '../../../Services';
import { seriliazeParams } from "../../../helpers/seriliazeParams";
import TicketTable from "../../../Components/TableComponents/TicketsTable";
import { showText } from "../../../helpers/textValidation";
import { Button, Switch } from "antd";
import CustomDropDownAutoComplete from "../../../Components/AntD/DropDown";
import { getAllLocomotiveTicketSources } from "../../../Services/LocomotiveServices";
import PgDynamicTable from "../../../Components/TableComponents/PgDynamicTable";
import moment from "moment";
import { TicketsTableHeader } from "../../../Components/TableComponents/constants";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
import { haveAccessByRole } from "../../../helpers";
const {
  hr,
  employee,
  Storage
} = Services;

const HR_CATEGORY_ID = 1;
const IT_CATEGORY_ID = 2;

const TicketsAndAlerts = () => {
  const [edit, setEdit] = useState(false)
  const [loader, setLoader] = useState(false)
  const [EmployeeListData, setEmployeeListData] = useState([])
  const [SwitchStatus, setSwitchStatus] = useState(true)
  const [sourceData, setSourceData] = useState([])

  var fetchPersistedFilter = (id) => {

    let existingFilters = JSON.parse(localStorage.getItem('TicketAlert_filter'))
    return existingFilters ? existingFilters[id] : null

  }

  const [sourceID, setSourceID] = useState(fetchPersistedFilter('sourceID'))
  const [pagination, setPagination] = useState({
    offSet: 0,
    limit: 10,
  })
  const [Count, setCount] = useState()
  const [test, setTest] = useState([])
  const [RequestedForId, setRequestedForId] = useState(fetchPersistedFilter('requestedFor'))
  const [selectedOpen, setSelectedOpen] = useState(fetchPersistedFilter('status') || 1)
  const [openCloseData, setopenCloseData] = useState([
    {
      label: "Open",
      value: 1
    },
    {
      label: "Close",
      value: 2
    },
    {
      label: "All",
      value: 3
    }
  ])



  const storage = new Storage()
  let location = useLocation(); // Get the current location

  let history = useHistory();
  const retrieveListing = async () => {
    let userProfile = await JSON.parse(localStorage.user_profile);
    let params = '?'.concat(seriliazeParams({ offset: pagination.offSet, limit: pagination.limit, isCompleted: selectedOpen, FEmployeeId: RequestedForId, TicketSourceId: sourceID }))
    try {
      setLoader(true)
      if (userProfile) {
        let categoryId = haveAccessByRole(18) ? 3 : (haveAccessByRole(2) || haveAccessByRole(3)) ? IT_CATEGORY_ID : HR_CATEGORY_ID
        let response = await hr.listTicketByCategory({ roleId: categoryId, params });
        const { data } = response;

        setCount(data?.count)
        const setTickets = data?.rows
          ?.map((rows) => ({
            id: rows?.id,
            employeeid: rows?.FEmployee?.id,
            name: showText(rows?.FEmployee?.firstName + " " + rows?.FEmployee?.lastName),
            alertType: rows?.isAlert ? "Alert" : "Ticket",
            department: rows?.TicketType?.name,
            senderEmail: showText(rows?.TicketSource?.name),
            description: rows?.creation_comment,
            isCompleted: rows?.isCompleted,
            category: rows?.TicketCategory?.name,
            openDate: rows?.OpenDate || rows?.createdAt,
            closeData: rows?.closeDate,
            categoryText: rows?.TicketCategoryText

          }))

        setTest(setTickets);
      }
    }
    catch (exc) {

    }
  }

  const getEmployeeData = async () => {
    let result = await employee.get_employee_listing_not_Terminated()
    if (result?.httpStatus === 200) {
      const data = result?.data.map((item, index) => {
        return {
          label: `${item?.firstName} ${item?.lastName}`,
          value: item?.id
        }
      })
      setEmployeeListData(data)
    }
  }
  const getAllTicketSource = async () => {
    const result = await getAllLocomotiveTicketSources()
    if (result?.httpStatus === 200) {
      setSourceData(result?.data)
    }
  }
  useEffect(async () => {
    retrieveListing()
  }, [SwitchStatus, RequestedForId, sourceID, pagination, selectedOpen])


  useEffect(() => {
    getAllTicketSource()
    getEmployeeData()
  }, [])
  const lastRoute = localStorage.getItem('last_route');

  useEffect(() => {
    // Reset filters if coming from a different route
    const resetFilters = () => {
      setSourceID(null);
      setRequestedForId(null);
      setSelectedOpen(1);
      localStorage.removeItem('TicketAlert_filter');
    };

    // Check the previous location to determine if filters should be reset
    if (lastRoute !== "/tickets-alerts/ticket/update") {
      resetFilters();
    }
  }, [location.pathname]);


  function onClickDetail(value) {
    history.push({
      pathname: "/tickets-alerts/ticket/update",
      state: { id: value?.id }
    });
    localStorage.setItem('TicketAlert_filter', JSON.stringify({ status: selectedOpen, requestedFor: RequestedForId, sourceID: sourceID }))

  }


  let table = {
    header: TicketsTableHeader,
    rows: test?.map(col => [
      showText(col?.id),
      showText(col?.name),
      showText(col?.alertType === 'Ticket' ? col?.senderEmail : col?.alertType),
      col?.openDate ? moment?.utc(col?.openDate)?.format("MM-DD-YYYY") : "N/A",
      col?.department,
      col?.category ? col?.category : col?.categoryText,
      <p style={{ textOverflow: "ellipsis", width: "300px", overflow: 'hidden', whiteSpace: "nowrap" }}>{showText(col?.description)}</p>,
      <Button onClick={() => onClickDetail(col)} className={col?.isCompleted ? "ViewIconNew" : "ViewIcon"}>{` `}</Button>,
    ])
  }

  useEffect(() => {
    setEdit(!edit)
  }, [RequestedForId, sourceID, SwitchStatus])

  return (
    <PageLayout className="Liq-Container NewHireQueue">
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">{`Tickets/Alerts`}</Grid>
        {/* Table Filters ----------------> */}
        <div style={{
          padding: "30px 0px",
          width: "100%",
          display: "flex",
          gap: "10px",
          alignItems: "center",
          justifyContent: "space-between"
        }}>
          <div style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            flexWrap: "wrap"
          }}>
            <CustomDropDownAutoComplete id='requestedFor' width='180px' items={EmployeeListData} selectedName={RequestedForId ? RequestedForId : " Requested For "} setSelectedName={setRequestedForId} />
            <CustomDropDownAutoComplete id='sourceID' width='180px' items={sourceData} selectedName={sourceID ? sourceID : " Source "} setSelectedName={setSourceID} />
            <CustomDropDownAutoComplete id='status' width='120px' items={openCloseData} selectedName={selectedOpen ? selectedOpen : "Status"} setSelectedName={setSelectedOpen} />
          </div>
          <div style={{ display: "flex", justifyContent: "end", }}>
            <Button onClick={() => {
              setSourceID()
              setRequestedForId()
              setSwitchStatus(true)
              setSelectedOpen(1)
              localStorage.removeItem('TicketAlert_filter')
            }} style={{ width: '100px', backgroundColor: "#2963ad", color: "white" }}>
              Reset
            </Button>
          </div>
        </div>

        <div >

          <PgDynamicTable tableData={table} setPagination={setPagination} pagination={pagination} edit={edit} count={Count} />
        </div>

      </Grid>
    </PageLayout>
  );
}

export default TicketsAndAlerts;
